import { gql } from '@apollo/client'

export const CHATBOT_CONVERSATION_FIELDS = gql`
  fragment ChatbotConversationFields on ChatbotConversation {
    id
    providerId
    kind
    title
    preview
    pinned
    reportId
    quickPromptId
    tags
    read
    createdAt
    updatedAt
  }
`
